import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenOrderItemStatusChange from '../../../views/app/common/OpenOrderItemStatusChange';
import { orderActions } from '../../../store/modules/order';

class OpenOrderItemStatusChangeContainer extends Component {
  render() {
    return <OpenOrderItemStatusChange {...this.props} />;
  }
}

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
};

export default connect(null, mapDispatchToProps)(OpenOrderItemStatusChangeContainer);
